<div class="wrapper">
  <app-document-table></app-document-table>
</div>
